import { get } from 'lodash'
import * as schemaFetcherV2 from '@wix/wix-data-client-common/dist/esm/business-logic/collections/schemaFetcherV2'
import { getDPCollectionName } from './getDPCollectionName'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type { PageRef, RouterRef } from '@wix/editor-platform-sdk-types'

const SANTA_TO_BI_ORIGINS = {
  idePagesTree: 'Left_tree',
  pagesPanel: 'pages_menu',
  sidebar: 'sidebar',
  pages_manager: 'pages_manager',
}

const getCollectionByPageRef = async ({
  editorSdkProxy,
  collectionsApi,
  routerRef,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  collectionsApi: CollectionsApi
  routerRef: RouterRef
  pageRef: PageRef
}) => {
  const collectionName = await getDPCollectionName({
    editorSdkProxy,
    routerRef,
    pageRef,
  })

  const collection = collectionName
    ? await schemaFetcherV2.fetch(collectionsApi, collectionName)
    : undefined

  return collection
}

type Params = {
  editorSdkProxy: EditorSDK
  collectionsApi: CollectionsApi
  pageRef: PageRef
  routerRef: RouterRef
  origin: keyof typeof SANTA_TO_BI_ORIGINS
  panelName: string
}

export const getBiDefaults = async ({
  editorSdkProxy,
  collectionsApi,
  pageRef,
  routerRef,
  origin,
  panelName,
}: Params) => {
  const collection = await getCollectionByPageRef({
    editorSdkProxy,
    collectionsApi,
    routerRef,
    pageRef,
  })
  return {
    pageId: pageRef.id,
    panel_name: panelName,
    origin: SANTA_TO_BI_ORIGINS[origin],
    collection_id: get(collection, 'id', null),
    collection_name: get(collection, 'displayName', null),
  }
}
